﻿import { DEFAULT_DEBOUNCE_TIME } from "@/config";
import { suggestionsType } from "@/propTypes";
import { Select, Spin } from "antd";
import DOMPurify from "dompurify";
import _ from "lodash";
import { arrayOf, bool, element, func, oneOfType, string } from "prop-types";
import { getDataTestId } from "./helper";

const { Option } = Select;

const ViperSelect = ({
  onChange,
  onFetchSuggestions,
  suggestions,
  placeholder,
  loading = false,
  value,
  allowMultipleSelections = false,
  onBlur,
  disabled = false,
  allowClear = false,
  dataTestId,
  customOptions,
  optionLabelProp,
}) => {
  const handleSearch = _.debounce((searchTerm) => {
    if (!searchTerm.trim()) return;
    value = searchTerm;
    onFetchSuggestions(searchTerm);
  }, DEFAULT_DEBOUNCE_TIME);

  const defaultOptions = suggestions?.map(({ value, label }) => (
    <Option key={value}>
      <span
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(label),
        }}
      />
    </Option>
  ));

  return (
    <Select
      placeholder={placeholder || undefined}
      data-test-id={getDataTestId(dataTestId, placeholder)}
      mode={allowMultipleSelections ? "multiple" : undefined}
      showSearch
      suffixIcon={null}
      style={{ width: "100%" }}
      value={value}
      defaultActiveFirstOption={false}
      filterOption={false}
      onSearch={handleSearch}
      onChange={onChange}
      optionLabelProp={optionLabelProp}
      notFoundContent={loading ? <Spin size="small" /> : null}
      onBlur={onBlur}
      getPopupContainer={(trigger) => trigger.parentElement}
      disabled={disabled}
      allowClear={allowClear}
      loading={loading}
    >
      {customOptions || defaultOptions}
    </Select>
  );
};

ViperSelect.propTypes = {
  onChange: func,
  onFetchSuggestions: func.isRequired,
  suggestions: suggestionsType,
  loading: bool,
  placeholder: string,
  value: oneOfType([string, arrayOf(string)]),
  allowMultipleSelections: bool,
  onBlur: func,
  disabled: bool,
  allowClear: bool,
  dataTestId: string,
  customOptions: arrayOf(element),
  optionLabelProp: string,
};

export default ViperSelect;
